/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { LocationPermissions } from './location-permissions.model';

export interface UserLocationPermission {
  locationId: number;
  locationName: string;
  permissions: LocationPermissions;
}

export enum UserPermissions {
  None = 0,
  CanManageOrganization = 1,
  CanManageUsers = 2,
  CanManageFormulary = 4,
  CanManageAdm = 8,
  CanManageAuth = 16,
  CanAccessLogs = 32,
  CanTrackAssets = 64,
  CanManageRules = 128,
  CanDownloadSoftware = 256,
}
